import React, { useState, useEffect, useCallback } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import 'react-toastify/dist/ReactToastify.css'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { chevronLeft, plus } from 'react-icons-kit/feather'
import ReactQuill from "react-quill";
import Requests from '../../../../utils/Requests/Index'
import Select from "react-select"
import LoadingComponent from '../../../../components/loading/Index'

const Edit = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [error, setError] = useState(null)
    const [isLoading, setLoading] = useState(true)
    const [update, setUpdate] = useState(false)
    const [item, setItem] = useState(null)
    const [selectedFile, setSelectedFile] = useState(null)
    const [value, setValue] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [items, setItems] = useState([]);
    const addItem = () => {
        if (inputValue.trim() === "") return;
        setItems([...items, inputValue]);
        setInputValue("");
    };
    
        const removeItem = (index) => {
            setItems(items.filter((_, i) => i !== index));
        };
    const handleChange = (content) => {
    setValue(content);
    // console.log(content);
    
    // if (onChange) onChange(content);
    };
    const [faqs, setFaqs] = useState([]);
    const [newFaq, setNewFaq] = useState({ question: "", answer: "" });
    // ✅ Add FAQ
    const addFaq = () => {
        if (!newFaq.question.trim() || !newFaq.answer.trim()) return alert("Please enter both question and answer!");
        setFaqs([...faqs, newFaq]);
        setNewFaq({ question: "", answer: "" });
    };
    
    // ✅ Remove FAQ
    const removeFaq = (index) => {
        const updatedFaqs = faqs.filter((_, i) => i !== index);
        setFaqs(updatedFaqs);
    };
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    // Fetch data
    const fetchData = useCallback(async () => {
        const data = await Requests.ProfilesByProfession.Show(id, header)
        if (data) {
            setItem(data)
            setValue(data.description || "");
            setItems(data.profileVerification)
            setFaqs(data.faq)
            setLoading(false)
        }
        setLoading(false)
    }, [id, header])

    useEffect(() => {
        fetchData()
    }, [id, header, fetchData])

    // Handle image
    const handleImage = async (event) => {
        const file = event.target.files[0]
        if (file) {
            const size = parseInt(file.size) / 1000
            if (size > 800) {
                setError({ ...error, image: 'Select less than 800KB file.' })
                return
            }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })

            let formData = new FormData()
            formData.append('image', file)
            setItem({ ...item, image: null })

            const response = await Requests.ProfilesByProfession.UpdateImage(id, formData, header)
            if (response.status === true) {
                toast.success(response.message)
            }
        }
    }

    // Submit Form
    const onSubmit = async (data) => {
        try {
            setUpdate(true)
            await Requests.ProfilesByProfession.Update(id, data, header)
            setUpdate(false)
            navigate('/dashboard/website/profiles-by-profession')
        } catch (error) {
            if (error) console.log(error)
        }
    }

    if (isLoading) return <LoadingComponent />

    return (
        <div className="store-story pb-4">

            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Edit Profile Profession</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/profiles-by-profession"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    {/*  Meta Title */}
                                        <div className="col-12">
                                            <div className="form-group mb-4">
                                                {errors.metaTitle && errors.metaTitle.message ? (
                                                    <p className="text-danger">{errors.metaTitle && errors.metaTitle.message}</p>
                                                ) : <p>Meta Title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="metaTitle"
                                                    defaultValue={item.metaTitle}
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Meta Title"
                                                    {...register("metaTitle", { required: "Title is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* metaDescription */}
                                        <div className="form-group mb-4">
                                            {errors.metaDescription && errors.metaDescription.message ? (
                                                <p className="text-danger">{errors.metaDescription && errors.metaDescription.message}</p>
                                            ) : <p>Meta Description</p>}

                                            <textarea
                                                type="text"
                                                name="metaDescription"
                                                defaultValue={item.metaDescription}
                                                rows={5}
                                                className="form-control shadow-none"
                                                placeholder="Enter Meta Description"
                                                {...register("metaDescription", { required: "Description is required" })}
                                            />
                                        </div>
                                    <div className="row">
                                        

                                        {/* Title */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.title && errors.title.message ? (
                                                    <p className="text-danger">{errors.title && errors.title.message}</p>
                                                ) : <p>Title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="title"
                                                    defaultValue={item.title}
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Title"
                                                    {...register("title",{ required: "Title is required" })}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.subBannerTitle && errors.subBannerTitle.message ? (
                                                    <p className="text-danger">{errors.subBannerTitle && errors.subBannerTitle.message}</p>
                                                ) : <p>Sub banner title</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="subBannerTitle"
                                                    defaultValue={item.subBannerTitle}
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Sub banner title"
                                                    {...register("subBannerTitle", { required: "Sub banner title is required" })}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group mb-4">
                                        {errors.bannerDescription && errors.bannerDescription.message ? (
                                            <p className="text-danger">{errors.bannerDescription && errors.bannerDescription.message}</p>
                                        ) : <p>Banner Short Description</p>}

                                        <textarea
                                            type="text"
                                            name="bannerDescription"
                                            rows={5}
                                            className="form-control shadow-none"
                                            placeholder="Enter Banner short description"
                                            {...register("bannerDescription", { required: "Banner Description is required" })}
                                        />
                                    </div>

                                    </div>

                                    <div className='row'>
                                        {/*  District */}
                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.district && errors.district.message ? (
                                                    <p className="text-danger">{errors.district && errors.district.message}</p>
                                                ) : <p>District</p>
                                                }

                                                <Select
                                                    classNamePrefix="custom-select"
                                                    styles={customStyles}
                                                    placeholder={"Select"}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    // options={items}
                                                    // defaultValue={defaultValueHandler(
                                                    //     query.manager,
                                                    //     items
                                                    // )}
                                                    // onChange={(event) => handleAssignTo(event)}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-6">
                                            <div className="form-group mb-4">
                                                {errors.district && errors.district.message ? (
                                                    <p className="text-danger">{errors.district && errors.district.message}</p>
                                                ) : <p>Profession</p>
                                                }

                                                <Select
                                                    classNamePrefix="custom-select"
                                                    styles={customStyles}
                                                    placeholder={"Select"}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    // options={items}
                                                    // defaultValue={defaultValueHandler(
                                                    //     query.manager,
                                                    //     items
                                                    // )}
                                                    // onChange={(event) => handleAssignTo(event)}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>
                                        
                                    </div>

                                    {/* description */}
                                    <div className="section-box border rounded p-3 mb-4 bg-white">
                                    <p className="section-title mb-3">Description</p>

                                    <ReactQuill
                                        value={value}
                                        defaultValue={item.description}
                                        onChange={handleChange}
                                        theme="snow"
                                        rows={5}
                                        className="bg-white"
                                    />
                                </div>

                                <div className="form-group mb-4">
                                        {errors.membersAreKnown && errors.membersAreKnown.message ? (
                                            <p className="text-danger">{errors.membersAreKnown && errors.membersAreKnown.message}</p>
                                        ) : <p>Profile Verification</p>}

                                        <ul className="list-group mb-3">
                                            {items.map((item, index) => (
                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                    {item}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => removeItem(index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>

                                        <div style={{ marginTop: "10px", display: "flex", gap: "8px" }}>
                                            <input
                                                type="text"
                                                placeholder="Enter members are known"
                                                value={inputValue}
                                                onChange={(e) => setInputValue(e.target.value)}
                                                style={{
                                                    flex: "1",
                                                    padding: "6px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                }}
                                            />
                                            <div
                                                onClick={addItem}
                                                className='btn btn-sm btn-danger'
                                                // style={{
                                                //     backgroundColor: "#007bff",
                                                //     color: "white",
                                                //     border: "none",
                                                //     borderRadius: "4px",
                                                //     padding: "6px 12px",
                                                //     cursor: "pointer",
                                                // }}
                                            >
                                                Add
                                            </div>
                                        </div>
                                    </div> 
                                    
                                    {/* FAQ*/}
                                    <div className="form-group mb-4">
                                        {errors.description && errors.description.message ? (
                                            <p className="text-danger">{errors.description && errors.description.message}</p>
                                        ) : <p>FAQ </p>}

                                        {faqs.length > 0 ? (
                                            faqs.map((faq, index) => (
                                                <div key={index} className="border rounded p-3 mb-3 bg-light">
                                                    <h6 className="fw-semibold mb-2">
                                                        {index + 1}. {faq.question}
                                                    </h6>
                                                    <p className="mb-2">{faq.answer}</p>
                                                    <div className='flex justify-content-end'>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() => removeFaq(index)}
                                                    >
                                                        Remove
                                                    </button></div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-muted"></p>//No FAQs added yet.
                                        )}

                                        {/* ✅ Add New FAQ */}
                                        <div className="border rounded p-3 bg-white">
                                            <h6 className="fw-semibold mb-3">Add New FAQ</h6>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder="Enter question"
                                                value={newFaq.question}
                                                onChange={(e) =>
                                                    setNewFaq({ ...newFaq, question: e.target.value })
                                                }
                                            />
                                            <textarea
                                                className="form-control mb-2"
                                                rows={3}
                                                placeholder="Enter answer"
                                                value={newFaq.answer}
                                                onChange={(e) =>
                                                    setNewFaq({ ...newFaq, answer: e.target.value })
                                                }
                                            />
                                            <div className="btn btn-success" onClick={addFaq}>
                                                Add FAQ
                                            </div>
                                        </div>
                                    </div>

                                    {/* Image upload Container */}
                                    <div className="form-group mb-4">
                                        {error && error.image ? <p className="text-danger">{error.image}</p> : <p>Image</p>}
                                        <div className="d-flex">
                                            {item && item.image ?
                                                <div className="img-container text-center mr-2">
                                                    <div className="image border">
                                                        <img src={item.image} className="img-fluid" alt="..." />
                                                    </div>
                                                </div>
                                                : selectedFile ?
                                                    <div className="img-container text-center mr-2">
                                                        <div className="image border">
                                                            <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                        </div>
                                                    </div>
                                                    : null}

                                            <div className="img-container text-center">
                                                <div className="image border">
                                                    <input type="file" className="upload" onChange={handleImage} />
                                                    <div className="flex-center flex-column">
                                                        <Icon icon={plus} size={22} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn shadow-none" disabled={update}>
                                            {update ? 'Updating...' : 'Update'}
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Edit;
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        height: 40,
        fontSize: 13,
        color: "#000",
        minWidth: 170,
        boxShadow: "none",
        "&:hover": { borderColor: "1px solid #ced4da" },
        border: state.isFocused ? "1px solid #dfdfdf" : "1px solid #ced4da",
        borderRadius: 0,
        menuPortal: base => ({ ...base, zIndex: 999 })
    }),
};
